// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Circle icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the CircleIcon component.
 * @returns {ReactElement} The CircleIcon component.
 */
export const CircleIcon = (props: IconProps) => (
  <Icon viewBox='0 0 200 200' {...props}>
    <path fill='currentColor' d='M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0' />
  </Icon>
);
